var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex items-center h-full" }, [
    _c(
      "button",
      {
        class: [
          _vm.enabled ? "bg-green-600" : "bg-gray-200",
          _vm.disabled ? "disabled" : "outline"
        ],
        attrs: { type: "button", "aria-labelledby": "toggle-label" },
        on: { click: _vm.clicked }
      },
      [
        _c("span", {
          class: _vm.enabled ? "enabled" : "",
          attrs: { "aria-hidden": "true" }
        })
      ]
    ),
    _c("span", { staticClass: "ml-3", attrs: { id: "toggle-label" } }, [
      _c("span", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }